// extracted by mini-css-extract-plugin
module.exports = {"root":"EntryPoint_root__2BYRQ"};